// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3415 ? "c36f3faa" : chunkId) + "." + {"1422":"a2d91af342033d8f","3415":"7c1e16fde2a76a14"}[chunkId] + ".js";
};